import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
`;

export const Button = styled.button`
	// layout
	display: flex;
	align-items: center;
	height: 32px;
	padding-left: 8px;
	padding-right: 8px;
	gap: 0px;

	// style
	font-size: 13px;
	font-weight: 400;
	background: ${({ theme }) => theme.blue[900]};
	color: ${({ theme }) => theme.gray[100]};
	&:hover {
		background: ${({ theme }) => theme.blue[1000]};
	}
	border: none;
	border-radius: 999px;
`;

export const IconWrapper = styled.span`
	display: flex;
	align-items: center;
`;

export const Label = styled.span`
	margin-left: 5px;
	margin-top: -1px;
`;
